export default __webpack_public_path__ + "static/media/sendMessageButton.9add4f6d.svg";